import { AbstractControl, ValidationErrors } from '@angular/forms';

const GUID_REGEXP = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/i;

export function isValidGuid(value: string): boolean {
  return GUID_REGEXP.test(value);
}

export function guidError(): ValidationErrors {
  return { invalidGUID: true };
}

export function guidValidator(control: AbstractControl): ValidationErrors | null {
  return !isValidGuid(control.value) ? guidError() : null;
}
